import { BranchTypesEnum } from 'src/app/shared/enums/branch-types.enum'
import { Gallery, workingHour } from 'src/app/shared/models/general.models'

export class BranchInformationModel {
	id!: number
	name!: string
	coverUrl!: string
	sliderImages!: Gallery[]
	landline!: string
	mobileNumbers: any = []
	commercialRegistrationNumber!: number
	commercialRegistrationUrl!: string
	maroofNumber!: number
	maroofUrl!: string
	targetAudience!: { targetAudience: number; canDelete: boolean }[]
	address!: string
	addressNote!: string
	latitude!: number
	longitude!: number
	isMain!: boolean
	workingHours!: workingHour[]
	reservationsNumberPerDay!: number
	reservationsNumberPerTimeSlot!: number
	facebookLink!: string
	twitterLink!: string
	instagramLink!: string
	tenantId!: number
	city!: City
	country!: {
		id: number
		name: {
			en: string
			ar: string
		}
		countryCode?:string
	}
	shortAddressEn!: string
	shortAddressAr!: string
	hasAppointments!: boolean
}

export interface City {
	id: number
	name: {
		en: string
		ar: string
	}
	position: {
		latitude: number
		longitude: number
	}
}

export interface UpdateLocationModel {
	address: string
	// addressNote: string
	id: number
	latitude: number
	longitude: number
	shortAddressAr: string
	shortAddressEn: string
}

export interface UpdateBasicInfoModel {
	id: number
	name: string
	isMain: boolean
	cityId: number
	// tenantId: number
}
export interface UpdateTargetAudienceModel {
	id: number
	targetAudiences: BranchTypesEnum[]
}
export interface UpdateSocialAccModel {
	id: number
	facebookLink: string
	instagramLink: string
}

export class isBranchInfoValid {
	isInfoValid = true
	isNameUnique = true
	uniqueNameErrorMessage = ''
	isLandlineUnique = true
	uniqueLandLineErrorMessage = ''
	mobileNumbers = []
}
